import { LoadingSkeleton } from '@coinbase/cdp-react/components/ui/LoadingSkeleton';
import { Text } from '@cbhq/cds-web/typography';

import styles from './LoadingInput.module.css';

type Props = {
  label?: string;
};

function LoadingRadioInputs({ label }: Props) {
  const keys = [1, 2, 3, 4, 5];
  return (
    <div className={styles['loading-input-wrapper']}>
      {label && (
        <Text font="label1" paddingY={0.5}>
          {label}
        </Text>
      )}
      <div className={styles['loading-radio-input-wrapper']}>
        {keys.map((key) => (
          <LoadingSkeleton className={styles['loading-radio-input']} key={key} />
        ))}
      </div>
    </div>
  );
}

export { LoadingRadioInputs };
